<template>
  <div>
    <div style="height: 70px;"></div>
    <div class="navbar">

      <div class="logo">
        <img src="~@/assets/images/logo-sm.png" alt="">
<!--        <h3><img src="~@/assets/images/new-logo-tit.png" alt=""></h3>-->
        <h3>甘肃省低速无人驾驶车辆（装备）测试示范服务平台</h3>
      </div>
      <top-nav id="topmenu-container" class="topmenu-container" v-if="settingsStore.topNav" />

      <div class="right-menu">
        <!-- 登录状态判断 -->
        <template v-if="userStore.token">
          <div class="avatar-container">
            <a-dropdown class="right-menu-item hover-effect" trigger="click">
              <div class="avatar-wrapper" style="color: #fff; padding: 0 12px; font-size: 16px;">
                您好，{{ userStore.nickName }}
                <DownOutlined style="color:#fff; margin-left: 8px; font-size: 14px" />
              </div>
              <template #overlay>
                <a-menu @click="handleCommand">
                  <a-menu-item>
                    <a @click="router.push('/userManagement/center')">个人中心</a>
                  </a-menu-item>
                  <a-menu-item key="logout" divided>
                    <span>退出登录</span>
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </div>
        </template>
        <!-- 未登录状态显示登录按钮 -->
        <template v-else>
          <div style="margin-left: 16px; display: flex; align-items: center; justify-content: center;">
            <a-button @click="router.push('/login')" class="login-btn">
              登录
            </a-button>
            <a-button @click="router.push('/register')" class="register-btn">
              注册
            </a-button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineEmits } from 'vue';
import { message, Modal } from 'ant-design-vue';
import { DownOutlined } from '@ant-design/icons-vue'
import TopNav from '@/components/TopNav'
import useUserStore from '@/store/modules/user'
import useSettingsStore from '@/store/modules/settings'
const { confirm } = Modal;

import { useRouter } from 'vue-router'

const router = useRouter()

const userStore = useUserStore()
const settingsStore = useSettingsStore()



function handleCommand(e) {
  switch (e.key) {
    case "setLayout":
      setLayout();
      break;
    case "logout":
      logout();
      break;
    default:
      break;
  }
}

function logout() {
  confirm({
    title: '提示',
    content: '确定退出系统吗？',
    okText: '确定',
    cancelText: '取消',
    type: 'warning',
    onOk() {
      userStore.logOut().then(() => {
        location.href = '/login';
      })
    },
    onCancel() { }
  });
}

const emits = defineEmits(['setLayout'])
function setLayout() {
  emits('setLayout');
}

function getInitials(name) {
  if (!name) return 'A';
  // 如果名字大于三个字，只取最后两个字
  if (name.length >= 3) {
    return name.substring(name.length - 2);
  }
  // 否则返回完整名字
  return name;
}

</script>

<style lang='scss' scoped>
.navbar {
  width: 100%;
  height: 70px;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  // background: #fff url(~@/assets/images/top_bg.png) no-repeat;
  padding: 10px 31px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 888888;

  // box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  .logo {
    display: flex;
    align-items: center;

    img {
      max-height: 60px;
    }

    h3 {
      margin: 0 0 0 16px;
      font-size: 28px;
      color: #fff;
      font-family: DingTalk;
    }
  }


  .topmenu-container {
    // position: absolute;
    // left: 50px;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    // 登录和注册按钮样式
    .login-btn, .register-btn {
      background: transparent;
      border: none;
      color: rgba(255, 255, 255, 0.95);
      font-size: 16px;
      padding: 8px 8px;
      margin: 0 4px;
      cursor: pointer;
      &:focus {
        outline: none;
      }
    }

    .avatar-container {
      margin-right: 40px;
      display: flex;
      align-items: center;
      justify-content: center;

      .avatar-wrapper {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        .user-avatar {
          cursor: pointer;
          width: 35px;
          height: 35px;
          border-radius: 50%;
          object-fit: cover;
        }

        .default-avatar {
          cursor: pointer;
          width: 35px;
          height: 35px;
          border-radius: 50%;
          background-color: #1890ff;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-weight: bold;
          font-size: 16px;
        }

        :deep(.anticon-down) {
          margin-left: 8px;
          color: #fff;
        }
      }
    }
  }
}

#topmenu-container {
  background: transparent !important;
  color: #E0F2FF;
  font-size: 16px;
  font-weight: 500;
  border-bottom: none;
}
</style>
